import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { isEmptyObject, openClearCartModal } from 'common/utilities/utils';
import {
  dispositionChangeAnalytics,
  modifyDataDisposition,
} from '../SelectContentDispositionUtilities/SelectContentDispositionUtil';
import { ButtonComp } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image';
import { UserOrderContext } from 'context/context';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { DISPOSITION_LIST, LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';

export const ExposedDispositionComponent = props => {
  const {
    SEARCH_ORDER_DATA,
    DISPOSITION_METHOD,
    SHOW_CLEAR_CART_ALERT,
    CLEAR_CART_CONFIRM_CANCEL_MODAL,
    clearCartExposedFlag,
    searchStoreAlertTitle,
  } = START_ORDER_CONSTANTS;
  const { contentDispositionData = {}, userParams } = props;
  const disposition = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW))?.type;
  const dispositionMethod = disposition?.toUpperCase();
  const [activeDisposition, setActiveDisposition] = useState(dispositionMethod);
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const { cartData = {} } = useSelector(state => state?.cartReducer);
  const dispositionContentData = isEmptyObject(contentDispositionData) && modifyDataDisposition(contentDispositionData);
  const {
    headline: contentText = '',
    subHeadline: infoText = null,
    supportedDispositionsData: orderTypes = [],
    src = '',
    alt,
  } = dispositionContentData;

  useEffect(() => {
    setActiveDisposition(dispositionMethod);
  }, [dispositionMethod]);

  const dispositionChange = (event, dispositionType) => {
    event.stopPropagation();
    event.preventDefault();
    dispositionChangeAnalytics(dispositionType);
    const selectedDispositionType = dispositionType?.trim();
    if (DISPOSITION_LIST.includes(selectedDispositionType)) {
      userOrderStateDispatch({
        type: DISPOSITION_METHOD,
        value: { dispositionType: selectedDispositionType },
      });
      if (cartData?.foodLines?.length > 0) {
        //open clear cart alert
        let modalOpenObj = { flag: clearCartExposedFlag, onConfirm: searchStoreAlertTitle };
        openClearCartModal(
          userOrderStateDispatch,
          modalOpenObj,
          SHOW_CLEAR_CART_ALERT,
          CLEAR_CART_CONFIRM_CANCEL_MODAL,
        );
      } else {
        userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: true } });
      }
    }
  };

  const showSelectOrderButtons = isEmptyObject(orderTypes) && userParams?.localized;

  return showSelectOrderButtons ? (
    <div className='select-content-disposition au'>
      <div className='stripes'>
        <ImageComponent srcFile={src} alt={alt || ''} />
      </div>
      <div className='disposition-headline'>{contentText}</div>
      <div role='alert' className='disposition-info-text'>
        <span>{infoText}</span>
      </div>
      <div className='disposition-btns mb-2'>
        {orderTypes?.map(({ buttonText, Id: id, dispositionType }) => {
          return (
            <ButtonComp
              className={
                activeDisposition === dispositionType?.toUpperCase()
                  ? 'button grayButton active-disposition'
                  : 'button grayButton'
              }
              key={id}
              data-testid={`button-${buttonText}`}
              onClickHandler={event => dispositionChange(event, dispositionType?.toUpperCase())}
              aria-label={buttonText}
            >
              {buttonText}
            </ButtonComp>
          );
        })}
      </div>
    </div>
  ) : null;
};
